import moment from 'moment';

/**
 * Ride class
 * @param {?Number} id
 * @param {?Date} datetime
 * @param {?String} status
 * @param {?Number} latitude
 * @param {?Number} longitude
 */
export default class User {
  constructor() {
    this.id = null;
    this.datetime = null;
    this.status = null;
    this.latitude = null;
    this.longitude = null;
  }

  set datetime(value) {
    this._datetime = value;
  }

  get datetime() {
    return this._datetime !== null ? moment(this._datetime) : null;
  }
}
